import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useUpcomingFromFavoriteAuthors(limit = 6) {
  return useQuery({
    queryKey: ['releases', 'from-favorite-authors', limit],
    queryFn: () => libraryApi.getUpcomingFromFavoriteAuthors(limit),
    staleTime: 60 * 60 * 1000,
  });
}
